import { render } from "./SuccessPage.vue?vue&type=template&id=b852c826&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"

import "./SuccessPage.vue?vue&type=style&index=0&id=b852c826&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b852c826"]])

export default __exports__